import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';

import * as MagayaNetworkConfigurationActions from './magaya-network-configuration.actions';
import { MagayaNetworkConfigurationEntity } from './magaya-network-configuration.models';

export const MAGAYANETWORKCONFIGURATION_FEATURE_KEY =
    'magayaNetworkConfiguration';

export interface State {
    magayaNetworkConfiguration?: MagayaNetworkConfigurationEntity;
    initialized: boolean;
    loading: boolean; // has the MagayaNetworkConfiguration list been loaded
    error?: string | null; // last known error (if any)
}

export interface MagayaNetworkConfigurationPartialState {
    readonly [MAGAYANETWORKCONFIGURATION_FEATURE_KEY]: State;
}

export const magayaNetworkConfigurationAdapter: EntityAdapter<MagayaNetworkConfigurationEntity> =
    createEntityAdapter<MagayaNetworkConfigurationEntity>();

export const initialState: State =
    magayaNetworkConfigurationAdapter.getInitialState({
        initialized: false,
        loading: false,
    });

const magayaNetworkConfigurationReducer = createReducer(
    initialState,
    on(MagayaNetworkConfigurationActions.init, state => ({
        ...state,
        loading: true,
        initialized: false,
        error: null,
    })),
    on(
        MagayaNetworkConfigurationActions.loadMagayaNetworkConfigurationSuccess,
        MagayaNetworkConfigurationActions.createMagayaNetworkConfigurationSuccess,
        MagayaNetworkConfigurationActions.updateMagayaNetworkConfigurationSuccess,
        MagayaNetworkConfigurationActions.testMagayaNetworkConfigurationSuccess,
        (state, { magayaNetworkConfiguration }) => ({
            ...state,
            loading: false,
            initialized: true,
            magayaNetworkConfiguration,
        })
    ),
    on(
        MagayaNetworkConfigurationActions.loadMagayaNetworkConfigurationFailure,
        MagayaNetworkConfigurationActions.createMagayaNetworkConfigurationFailure,
        MagayaNetworkConfigurationActions.updateMagayaNetworkConfigurationFailure,
        MagayaNetworkConfigurationActions.testMagayaNetworkConfigurationFailure,
        (state, { error }) => ({
            ...state,
            error,
            loading: false,
            initialized: true,
        })
    ),
    on(
        MagayaNetworkConfigurationActions.createMagayaNetworkConfiguration,
        MagayaNetworkConfigurationActions.updateMagayaNetworkConfiguration,
        MagayaNetworkConfigurationActions.testMagayaNetworkConfiguration,
        state => ({
            ...state,
            loading: true,
            error: null,
        })
    ),
    on(MagayaNetworkConfigurationActions.dismissError, state => ({
        ...state,
        error: null,
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return magayaNetworkConfigurationReducer(state, action);
}
